import { render, staticRenderFns } from "./ProfileServer.vue?vue&type=template&id=318d07ba&"
import script from "./ProfileServer.vue?vue&type=script&lang=js&"
export * from "./ProfileServer.vue?vue&type=script&lang=js&"
import style0 from "./ProfileServer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports